import _ from 'lodash';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import * as Styled from './styled';

export type ExternalLinksListItemProps = {
	title?: string;
	url: string;
	children?: JSX.Element;
	iconColor?: string;
	color: string;
	disabled: boolean;
};

const ExternalLinksListItem: React.FunctionComponent<
	ExternalLinksListItemProps
> = (props: ExternalLinksListItemProps) => (
	<Styled.LiBorder>
		<Styled.ListAnchor
			href={props.url}
			target="_blank"
			color={props.color}
			analyticsId={_.kebabCase(props.title)}
			disabled={props.disabled}
		>
			{props.children}
			<span className="sr-only">, opens in a new window.</span>
			<Styled.ExternalLinkIcon color={props.iconColor}>
				<FontAwesomeIcon icon={faExternalLink} size="xs" />
			</Styled.ExternalLinkIcon>
		</Styled.ListAnchor>
	</Styled.LiBorder>
);
export default ExternalLinksListItem;
